"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CJForm = exports.useCJForm = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var R = __importStar(require("../../utils/ramda"));
require("./CJForm.css");
var react_hook_form_1 = require("react-hook-form");
var CJFormContext_1 = require("./CJFormContext");
var util_1 = require("./util");
var Row_1 = require("../../components/Row");
var classnames_1 = __importDefault(require("classnames"));
var CJFormLayout_1 = require("./CJFormLayout");
var useRandomGuid_1 = require("../../hooks/useRandomGuid");
var useCJForm = function (props) {
  var defaultProps = {
    mode: "onTouched"
  };
  var outputProps = R.mergeRight(defaultProps, props !== null && props !== void 0 ? props : {});
  var useFormReturn = (0, react_hook_form_1.useForm)(outputProps);
  var _a = __read((0, useRandomGuid_1.useRandomGuid)(), 1),
    submitTriggerId = _a[0];
  var submitForm = (0, react_1.useCallback)(function () {
    var _a;
    return (_a = document.getElementById(submitTriggerId)) === null || _a === void 0 ? void 0 : _a.click();
  }, [submitTriggerId]);
  return __assign({
    submitForm: submitForm,
    submitTriggerId: submitTriggerId
  }, useFormReturn);
};
exports.useCJForm = useCJForm;
var CJForm = function (props) {
  var _a = __read((0, util_1.extractRHF)(props), 2),
    _b = _a[0],
    formProps = _a[1],
    children = _b.children,
    className = _b.className,
    _c = _b.onSubmit,
    onSubmit = _c === void 0 ? R.N : _c,
    heading = _b.heading,
    _d = _b.showRequiredIndicator,
    showRequiredIndicator = _d === void 0 ? false : _d,
    _e = _b.requiredIndicatorText,
    requiredIndicatorText = _e === void 0 ? "required fields" : _e,
    _f = _b.width,
    width = _f === void 0 ? "narrow" : _f,
    _g = _b.layoutGrid,
    layoutGrid = _g === void 0 ? true : _g,
    _h = _b.selectedId,
    selectedId = _h === void 0 ? "" : _h,
    _j = _b.selectTab,
    selectTab = _j === void 0 ? R.N : _j,
    _k = _b.submitTriggerId,
    submitTriggerId = _k === void 0 ? "" : _k,
    _l = _b.submitForm,
    submitForm = _l === void 0 ? R.N : _l,
    _m = _b.requiredErrorText,
    requiredErrorText = _m === void 0 ? "This field is required" : _m,
    _o = _b.sectionErrorText,
    sectionErrorText = _o === void 0 ? "This section contains at least one error." : _o,
    restProps = __rest(_b, ["children", "className", "onSubmit", "heading", "showRequiredIndicator", "requiredIndicatorText", "width", "layoutGrid", "selectedId", "selectTab", "submitTriggerId", "submitForm", "requiredErrorText", "sectionErrorText"]);
  return (
    //@ts-ignore --> This is required for CJFormContext to accept typed values
    (0, jsx_runtime_1.jsx)(CJFormContext_1.CJFormContext.Provider, __assign({
      value: __assign({
        width: width,
        selectedId: selectedId,
        selectTab: selectTab,
        sectionErrorText: sectionErrorText,
        requiredErrorText: requiredErrorText
      }, formProps)
    }, {
      children: (0, jsx_runtime_1.jsxs)("form", __assign({
        onSubmit: formProps.handleSubmit(onSubmit),
        className: (0, classnames_1.default)("vsx-cjform", className),
        noValidate: true
      }, restProps, {
        children: [(0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
          justify: "space-between",
          align: "center",
          gap: "medium",
          paddingBottom: "xl"
        }, {
          children: [(0, jsx_runtime_1.jsx)("div", __assign({
            className: "vsx-cjform-heading"
          }, {
            children: heading
          })), showRequiredIndicator && (0, jsx_runtime_1.jsxs)("div", __assign({
            className: "vsx-cjform-required-indicator"
          }, {
            children: ["* = ", requiredIndicatorText]
          }))]
        })), (0, jsx_runtime_1.jsx)(CJFormLayout_1.CJFormLayoutGrid, {
          children: children
        }), (0, jsx_runtime_1.jsx)("button", {
          type: "submit",
          id: submitTriggerId,
          style: {
            display: "none"
          }
        })]
      }))
    }))
  );
};
exports.CJForm = CJForm;